import createClient from "openapi-fetch";
import { env } from "@/env";
import type { paths } from "./types";

/**
 * Base API client for unauthenticated endpoints.
 * Use this for public endpoints like login, signup, etc.
 *
 * For authenticated endpoints, use the authClient from auth-client.ts
 */
export const apiClient = createClient<paths>({
	baseUrl: env.VITE_API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
	},
});
